import React from 'react';
import { FileText, CheckCircle, AlertTriangle, AlertCircle, Clock } from 'lucide-react';
import './StatsBar.css';

const StatsBar = ({ stats }) => {
  if (!stats) return null;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('hr-HR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount || 0);
  };

  return (
    <div className="stats-bar">
      <div className="stat-item">
        <FileText size={20} />
        <div className="stat-content">
          <div className="stat-value">{stats.total_invoices || 0}</div>
          <div className="stat-label">Total Invoices</div>
        </div>
      </div>
      
      <div className="stat-item">
        <CheckCircle size={20} className="stat-icon valid" />
        <div className="stat-content">
          <div className="stat-value">{stats.valid_invoices || 0}</div>
          <div className="stat-label">Valid</div>
        </div>
      </div>
      
      <div className="stat-item">
        <AlertTriangle size={20} className="stat-icon warning" />
        <div className="stat-content">
          <div className="stat-value">{stats.warning_invoices || 0}</div>
          <div className="stat-label">Warnings</div>
        </div>
      </div>
      
      <div className="stat-item">
        <AlertCircle size={20} className="stat-icon error" />
        <div className="stat-content">
          <div className="stat-value">{stats.error_invoices || 0}</div>
          <div className="stat-label">Errors</div>
        </div>
      </div>
      
      <div className="stat-item">
        <Clock size={20} className="stat-icon unchecked" />
        <div className="stat-content">
          <div className="stat-value">{stats.unchecked_invoices || 0}</div>
          <div className="stat-label">Unchecked</div>
        </div>
      </div>
      
      <div className="stat-item highlight">
        <div className="stat-content">
          <div className="stat-value">{formatCurrency(stats.total_amount)}</div>
          <div className="stat-label">Total Amount</div>
        </div>
      </div>
      
      <div className="stat-item">
        <div className="stat-content">
          <div className="stat-value">
            {stats.processed_files || 0} / {stats.total_files || 0}
          </div>
          <div className="stat-label">Files Processed</div>
        </div>
      </div>
    </div>
  );
};

export default StatsBar;